window.customElements.define('countdown-timer',
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.timer = null;
      this.interval = null;
      this.timer = this.querySelector('[data-timer]');
      this.isDailyCountdown = this.dataset.dailyCountdown === 'true';

      if (this.isDailyCountdown) {
        this.startDailyTimer();
      } else {
        const { year, month, day } = this.dataset;
        this.endDate = new Date(year, month - 1, day);
        this.startTimer();
      }
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    startTimer() {
      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    startDailyTimer() {
      this.updateDailyTimer();
      this.interval = setInterval(() => this.updateDailyTimer(), 1000);
    }

    stopTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    updateTimer() {
      const now = new Date();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.stopTimer();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.timer.textContent = `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
    }

    updateDailyTimer() {
      const now = new Date();

      // Calculate midnight tonight in user's local timezone
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);

      const distance = midnight - now;

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.timer.textContent = `${hours}h : ${minutes}m : ${seconds}s`;
    }
  });

// Initialize countdown timers inside marquee-text (scrolling mode)
// These timers are not inside a countdown-timer web component, so we need to handle them separately
function initMarqueeTimers() {
  const marqueeTimers = document.querySelectorAll('marquee-text [data-timer]');
  if (!marqueeTimers.length) return;

  // Group timers by their configuration to share a single interval
  const dailyTimers = [];
  const fixedTimers = [];

  marqueeTimers.forEach((timerEl) => {
    if (timerEl.dataset.dailyCountdown === 'true') {
      dailyTimers.push(timerEl);
    } else if (timerEl.dataset.year) {
      fixedTimers.push({
        el: timerEl,
        endDate: new Date(timerEl.dataset.year, timerEl.dataset.month - 1, timerEl.dataset.day),
      });
    }
  });

  // Update all daily countdown timers
  if (dailyTimers.length) {
    const updateDailyTimers = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const distance = midnight - now;

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const text = `${hours}h : ${minutes}m : ${seconds}s`;
      dailyTimers.forEach((el) => (el.textContent = text));
    };
    updateDailyTimers();
    setInterval(updateDailyTimers, 1000);
  }

  // Update all fixed date countdown timers
  if (fixedTimers.length) {
    const updateFixedTimers = () => {
      const now = new Date();
      fixedTimers.forEach(({ el, endDate }) => {
        const distance = endDate - now;
        if (distance < 0) {
          el.textContent = '0d : 0h : 0m : 0s';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        el.textContent = `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
      });
    };
    updateFixedTimers();
    setInterval(updateFixedTimers, 1000);
  }
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarqueeTimers);
} else {
  initMarqueeTimers();
}